(function () {
  "use strict";

  angular.module("app.core").config([
    "$stateProvider",
    function ($stateProvider) {
      $stateProvider.state("share-portfolio", {
        url: "/:langcode/sizin-icin-buldum/:id",
        templateUrl: "app/share/share.html",
        controller: "ShareController",
        params: {
          langcode: {
            value: ['$translate', function ($translate) {
              return $translate.use();
          }]
          }
        },
        resolve: {
          lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
            return lazyLoadSvc.load($transition$, 'share');
          }],

          title: [
            "$stateParams",
            function ($stateParams) {
              return $stateParams.langcode === "tr"
                ? "Sizin İçin Bulduğum Portföyler"
                : "I Found For You";
            },
          ],

          description: [
            "$stateParams",
            function ($stateParams) {
              return $stateParams.langcode === "tr"
                ? "Bulduğum portföyleri buradan inceleyebilir, bulundukları mahalle hakkında bilgilere ulaşabilir ve gayrimenkul piyasa detaylarını görebilirsiniz."
                : "You can see portfolio details, photos, neighborhood information and real estate market details from here.";
            },
          ],

          translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
            $translatePartialLoader.addPart("share");
            return $translate.refresh();
          }],
          shared: [
            "shareAPI",
            "$transition$",
            function (shareAPI, $transition$) {
              var id = $transition$.params().id;
              return shareAPI.get({ sharedId: id }).$promise;
            },
          ],
        },
        metaTags: {
          robots: "noindex, nofollow",
          title: "{{title}}",
          description: "{{description}}"
        }
      });
    },
  ]);
})();
